import { render, staticRenderFns } from "./SaleEditAwsDocumentsOptionsModal.vue?vue&type=template&id=0879326e&scoped=true"
import script from "./SaleEditAwsDocumentsOptionsModal.vue?vue&type=script&lang=ts"
export * from "./SaleEditAwsDocumentsOptionsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879326e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0879326e')) {
      api.createRecord('0879326e', component.options)
    } else {
      api.reload('0879326e', component.options)
    }
    module.hot.accept("./SaleEditAwsDocumentsOptionsModal.vue?vue&type=template&id=0879326e&scoped=true", function () {
      api.rerender('0879326e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditAwsDocumentsOptionsModal.vue"
export default component.exports